//////// GHG 3.3 EA
const threeThreeSchema = {
  title: "3.3 Fuel and Energy-related Activities(not included in Scope 1 or Scope 2)",
  addAPI: "cat4_1AddEmissionActivityAPI",
  cat: "cat4_1",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "ghgActivityNameId",
      level: 1,
      type: "select",
      label: "Activity Type",
      optionsAPI: "ghg3_3ActivityDropdown",
      resetOnChange: true,
      required: false,
    },
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Supplier Name",
      resetOnChange: false,
      required: false,
    },
  ],
};

export default threeThreeSchema;
